"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleCoverageSchema = exports.UNLIMITED_COVERAGE_LIMIT = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
exports.UNLIMITED_COVERAGE_LIMIT = 999999999999999;
exports.impossibleCoverageSchema = zod_1.z
    .object({
    name: constants_1.defaultString,
    premiumCents: zod_1.z.nullable(zod_1.z.number().min(0)),
    deductibleCents: zod_1.z.nullable(zod_1.z.number().min(0)).optional(),
    isDeclined: zod_1.z.nullable(zod_1.z.boolean()),
}).strict();
